import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { matchingApi } from '../api/matching';
import { Match, ProfileWithUser } from '../types';
import { useAuthStore } from '../store/authStore';
import './Matches.css';

export const Matches: React.FC = () => {
  const [matches, setMatches] = useState<Match[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    loadMatches();
  }, []);

  const loadMatches = async () => {
    try {
      const data = await matchingApi.getMatches();
      setMatches(data);
    } catch (error: any) {
      console.error('Failed to load matches:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getOtherUserProfile = (match: Match): ProfileWithUser | undefined => {
    if (!user) return undefined;
    return match.userId1 === user.id ? match.user2Profile : match.user1Profile;
  };

  const handleMatchClick = (match: Match) => {
    navigate(`/chat/${match.id}`);
  };

  if (isLoading) {
    return (
      <div className="matches-container">
        <div className="loading">Loading matches...</div>
      </div>
    );
  }

  return (
    <div className="matches-container">
      <div className="matches-header">
        <h1>Your Matches</h1>
        <p>{matches.length} {matches.length === 1 ? 'match' : 'matches'}</p>
      </div>

      {matches.length === 0 ? (
        <div className="no-matches">
          <h2>No matches yet</h2>
          <p>Keep swiping to find your match!</p>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/')}
          >
            Start Swiping
          </button>
        </div>
      ) : (
        <div className="matches-grid">
          {matches.map((match) => {
            const otherUser = getOtherUserProfile(match);
            if (!otherUser) return null;

            const mainPhoto = otherUser.photos.sort((a, b) => a.order - b.order)[0];

            return (
              <div 
                key={match.id}
                className="match-card"
                onClick={() => handleMatchClick(match)}
              >
                <div 
                  className="match-card-image"
                  style={{
                    backgroundImage: mainPhoto 
                      ? `url(${mainPhoto.url})` 
                      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  }}
                >
                  {!mainPhoto && (
                    <div className="match-card-placeholder">
                      <span>{otherUser.firstName[0]}</span>
                    </div>
                  )}
                </div>
                <div className="match-card-info">
                  <h3>{otherUser.firstName}</h3>
                  <p>{otherUser.department}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
